var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenEditorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 41"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    opacity: 0.05,
    cx: 28.2133,
    cy: 27.7445,
    r: 27.7445,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Draw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0015 39.5895C15.0015 38.8347 15.5392 38.2228 16.2025 38.2228H40.2238C40.8871 38.2228 41.4248 38.8347 41.4248 39.5895C41.4248 40.3443 40.8871 40.9562 40.2238 40.9562H16.2025C15.5392 40.9562 15.0015 40.3443 15.0015 39.5895Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8718 15.6089C35.4969 14.1741 33.2676 14.1741 31.8925 15.6089L19.3651 28.681C18.8916 29.1751 18.563 29.7998 18.4177 30.482L17.7924 33.418C17.4197 35.168 18.9159 36.7293 20.593 36.3404L23.4068 35.6879C24.0604 35.5363 24.6591 35.1934 25.1326 34.6994L37.66 21.6272C39.0351 20.1924 39.0351 17.8662 37.66 16.4314L36.8718 15.6089ZM33.5523 17.3409C34.0106 16.8626 34.7537 16.8626 35.2121 17.3409L36.0003 18.1633C36.4586 18.6416 36.4586 19.417 36.0003 19.8953L33.745 22.2486L31.297 19.6942L33.5523 17.3409ZM29.6372 21.4261L21.0249 30.413C20.867 30.5776 20.7575 30.7859 20.7091 31.0132L20.0838 33.9494L22.8976 33.2969C23.1155 33.2464 23.315 33.132 23.4729 32.9673L32.0852 23.9805L29.6372 21.4261Z",
    fill: "#323232"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEditorIcon);
export default __webpack_public_path__ + "static/media/penEditorIcon.2011225b275f9cfb9e5ae3e4524d8616.svg";
export { ForwardRef as ReactComponent };